const React = require('react');
const _findIndex = require('../../../../utils/findIndex.js');
const helper = require('../../../../helper/dish-helper');
import Counter from '../../../mui/counter.jsx';
import HttpsProtocolImage from '../../../common/https-protocol-image';
const DishDetailHead = require('../dish-detail-head.jsx');
const DishPropsSelect = require('../dish-props-select.jsx');
const toastIcon = require('../../../../asset/images/warning-white.svg');
window.I = require('seamless-immutable');
const classnames = require('classnames');
require('./child-dish.scss');
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../../../intl/helper';
import dishMenuMessages from '../../../../intl/messages/dish-menu';
import globalMessages from '../../../../intl/messages/global';
let addToGroupFlag = false;

module.exports = React.createClass({
  displayName: 'GroupDishDetailChildDish',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    remainCount: React.PropTypes.number.isRequired,
    onDishChange: React.PropTypes.func.isRequired,
    forCartModal: React.PropTypes.bool,
    onDishModalShow: React.PropTypes.func,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  getInitialState() {
    const { dish } = this.props;
    return {
      tempDish: dish,
      deleteDish: dish,
      deleteDishCopy: dish,
      expand: false,
      deleteExpand: false,
      toast: 0,
      toastText: '',
    };
  },
  onCountChange(newCount, increment) {
    const { dish, onDishChange } = this.props;
    const oldCount = helper.getDishesCount([dish]);

    if (oldCount === 0) {
      newCount = dish.leastCellNum;
    } else if (oldCount + increment < dish.leastCellNum) {
      newCount = 0;
    } else {
      newCount = oldCount + increment;
    }

    onDishChange(dish.update('order', order => (helper.isSingleDishWithoutProps(dish) ? newCount : order.setIn([0, 'count'], parseInt(newCount, 10)))));
  },
  onCountChange2(newCount, increment) {
    const dishForTemp = this.state.tempDish;
    const oldCount = helper.getDishesCount([dishForTemp]);

    // if (oldCount === 0) {
    //   newCount = dishForTemp.leastCellNum;
    // } else if (oldCount + increment < dishForTemp.leastCellNum) {
    //   newCount = 0;
    // } else {
    //   newCount = oldCount + increment;
    // }
    newCount = oldCount + increment;
    if (helper.isSingleDishWithoutProps(dishForTemp)) {
      this.setState({ tempDish: dishForTemp.set('order', newCount) });
    } else {
      this.setState({
        tempDish: dishForTemp.setIn(['order', 0, 'count'], newCount),
      });
    }
  },
  onOrderDish(tempDish) {
    const { dish, onDishChange } = this.props;
    // for single dish with props
    const orderIdx = _findIndex(
      dish.order === undefined ? [] : dish.order,
      // { dishPropertyTypeInfos:payload[0].order[0].dishPropertyTypeInfos }
      { dishIngredientInfos: tempDish.order[0].dishIngredientInfos, dishPropertyTypeInfos: tempDish.order[0].dishPropertyTypeInfos },
    );
    if (orderIdx !== -1) {
      if (tempDish.order[0].count === 0) {
        return;
      }
      const count = dish.order[orderIdx].count + tempDish.order[0].count;
      // if find the order with same props, just add the count of the exsited order;
      onDishChange(dish.setIn(['order', orderIdx, 'count'], count));
      if (count <= 0) {
        // if order's count is 0, remove it.
        onDishChange(
          dish
            .updateIn(['order'], order => order.flatMap((eachOrder, idx) => (orderIdx === idx ? [] : eachOrder)))
            .updateIn(['order'], order => order.flatMap(eachorder => (eachorder.count === 0 ? [] : eachorder))),
        );
      }
    } else {
      // if cannot find the order with same props,add it as new order;
      // if order's count is 0, remove it.
      onDishChange(
        dish
          .updateIn(['order'], order => (order === undefined ? tempDish.order : order.concat(tempDish.order)))
          .updateIn(['order'], order => order.flatMap(eachorder => (eachorder.count === 0 ? [] : eachorder))),
      );
    }
  },
  /**
   * 校验
   * 增加必选校验
   * @return boolean
   */
  valid() {
    let res = true;
    const { tempDish } = this.state;
    if (!tempDish || !tempDish.hasOwnProperty('order') || !Array.isArray(tempDish.order) || !tempDish.order[0]) return res; // 不满足条件都默认校验通过
    const { dishPropertyTypeInfos } = tempDish.order[0];
    if (!dishPropertyTypeInfos || !Array.isArray(dishPropertyTypeInfos)) return res;
    for (let i = 0, l = dishPropertyTypeInfos.length; i < l; i++) {
      const { isMandatory, properties, name } = dishPropertyTypeInfos[i];
      if (isMandatory === 1) {
        // 选项中没有一个被设置为选中
        if (!properties.some(pro => pro.isChecked)) {
          this.setState({ toast: 1, toastText: `请选择${name}` });
          setTimeout(() => {
            this.setState({ toast: 0 });
          }, 1000);
          res = false;
          break;
        }
      }
    }
    return res;
  },
  onAddToGroupTap() {
    if (!this.valid()) return;
    const { tempDish } = this.state;
    // 未选择菜品份数
    if (!addToGroupFlag) {
      this.setState({ toast: 1, toastText: <FormattedMessage {...dishMenuMessages.notChooseDish} /> });
      setTimeout(() => {
        this.setState({ toast: 0 });
      }, 3000);
      return;
    }
    this.onOrderDish(tempDish);
    this.onCloseModalTap();
  },
  onDeleteToGroupTap() {
    const { dish, onDishChange } = this.props;
    const { deleteDishCopy, deleteDish } = this.state;
    const state = false;
    let cnt = 0;
    let leastCnt = 0;
    for (let i = 0; i < deleteDish.order.length; i++) {
      const dishOrder = deleteDish.order[i];
      if (dishOrder.countChange === undefined || dishOrder.count === dishOrder.countChange) {
        cnt += 1;
      }
      leastCnt += dishOrder.countChange === undefined ? dishOrder.count : dishOrder.countChange;
    }
    if (state || cnt === deleteDish.order.length) {
      this.setState({ toast: 1, toastText: <FormattedMessage {...dishMenuMessages.chooseDeleteDish} /> });
      setTimeout(() => {
        this.setState({ toast: 0 });
      }, 3000);
      return;
    }
    // 必选菜必须保留起卖份数
    if (deleteDish.isReplace && deleteDish.leastCellNum > leastCnt) {
      this.setState({
        toast: 1,
        toastText: <FormattedMessage {...dishMenuMessages.keepLeastCellNum} values={{ leastCellNum: deleteDish.leastCellNum }} />,
      });
      setTimeout(() => {
        this.setState({ toast: 0 });
      }, 3000);
      return;
    }

    const dOrder = deleteDishCopy.updateIn(['order'], order => order.flatMap((eachOrder, idx) => (eachOrder.count === 0 && idx !== 0 ? [] : eachOrder)));
    onDishChange(dish.setIn(['order'], dOrder.order));
    this.onCloseDeleteModalTap();
  },
  onDeleteToGroupTap2(evt) {
    const { dish, onDishChange } = this.props;
    this.onSetBlockIdx(evt);
    onDishChange(
      dish
        .updateIn(['order'], order => order.flatMap((eachOrder, idx) => (idx !== 0 ? [] : eachOrder)))
        .setIn(['order', 0, 'count'], 0)
        .updateIn(['order', 0, 'dishIngredientInfos'], infos => infos.flatMap(info => info.set('isChecked', false)))
        .updateIn(['order', 0, 'dishPropertyTypeInfos'], infos =>
          infos.flatMap(info => info.update('properties', props => props.flatMap(prop => prop.set('isChecked', false)))),
        ),
    );
  },
  onSelectPropsOption(propData, optionData) {
    const { dish, onDishChange } = this.props;
    let propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dish.order[0].dishPropertyTypeInfos, { id: propData.id });
        onDishChange(
          dish.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              } else if (option.id !== optionData.id && option.isChecked === true) {
                return option.set('isChecked', false);
              }
              return option;
            }),
          ),
        );
        break;
      case 3:
        propIdx = _findIndex(dish.order[0].dishPropertyTypeInfos, { id: propData.id });
        onDishChange(
          dish.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            }),
          ),
        );
        break;
      case -1: // this is a client workround for ingredientsData, we don't have this value of type on serverside
        onDishChange(
          dish.updateIn(['order', 0, 'dishIngredientInfos'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            }),
          ),
        );
        break;
      default:
    }
  },
  onDishItemCountChange(increment) {
    const dishForDetail = this.state.tempDish;
    const dishForCart = this.props.dish;
    const countForDetail = helper.getDishesCount([dishForDetail]);
    const countForCart = helper.getDishesCount([dishForCart]);
    let newCountForDetail;

    if (countForDetail === 0 && countForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishForDetail.dishIncreaseUnit;
    } else if (countForCart === 0 && countForDetail + increment < dishForDetail.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = countForDetail + increment;
    }

    if (helper.isSingleDishWithoutProps(dishForDetail)) {
      this.setState({ tempDish: dishForDetail.set('order', newCountForDetail) });
    } else {
      this.setState({
        tempDish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail),
      });
    }
  },
  onSelectPropsOption2(propData, optionData) {
    const dishForTemp = this.state.tempDish;
    let propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dishForTemp.order[0].dishPropertyTypeInfos, { id: propData.id });
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // } else if (option.id !== optionData.id && option.isChecked === true) {
              //   return option.set('isChecked', false);
              // }
              // return option;
              let isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              } else if (option.id !== optionData.id && option.isChecked === true) {
                isChecked = false;
              }
              return option.set('isChecked', isChecked);
            }),
          ),
        });
        break;
      case 3:
        propIdx = _findIndex(dishForTemp.order[0].dishPropertyTypeInfos, { id: propData.id });
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // }
              // return option;
              let isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              }
              return option.set('isChecked', isChecked);
            }),
          ),
        });
        break;
      case -1: // this is a client workround for ingredientsData, we don't have this value of type on serverside
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishIngredientInfos'], options =>
            options.flatMap(option => {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // }
              // return option;
              let isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              }
              return option.set('isChecked', isChecked);
            }),
          ),
        });
        break;
      default:
    }
  },
  onSetBlockIdx(evt) {
    let target = evt.target;
    while (target.className.indexOf('group-block') === -1) {
      target = target.parentNode;
    }
    target.parentNode.setAttribute('data-blockidx', target.getAttribute('data-idx'));
  },
  onPropsBtnTap(evt) {
    const dish = this.props.dish;
    const dishCount = dish.order.map(order => order.count).reduce((c, p) => c + p, 0);
    let count = dish.leastCellNum;

    if (dishCount >= dish.leastCellNum) {
      count = 1;
    }

    this.onSetBlockIdx(evt);

    this.setState(
      {
        expand: !this.state.expand,
        tempDish: this.state.tempDish.setIn(['order', 0, 'count'], count),
      },
      () => {
        this.props.handleChangeExpand(this.state.expand);
      },
    );

    addToGroupFlag = true;
    this.props.onDishModalShow(true);
  },
  onCloseModalTap(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    let dishForTemp = this.state.tempDish;

    if (helper.isSingleDishWithoutProps(dishForTemp)) {
      dishForTemp = dishForTemp.set('order', 0);
    } else {
      dishForTemp = dishForTemp.setIn(['order', 0], this.props.dish.order[0]).setIn(['order', 0, 'count'], 0);
    }

    this.setState(
      {
        expand: !this.state.expand,
        tempDish: dishForTemp,
      },
      () => {
        this.props.handleChangeExpand(this.state.expand);
      },
    );
    this.props.onDishModalShow(false);
  },
  onCloseDeleteModalTap() {
    this.setState({
      deleteExpand: !this.state.deleteExpand,
    });
    this.props.onDishModalShow(false);
  },
  onDishDeleteTap(evt) {
    const { dish } = this.props;

    this.onSetBlockIdx(evt);
    this.setState({
      deleteExpand: !this.state.deleteExpand,
      deleteDish: dish,
      deleteDishCopy: dish,
    });
    this.props.onDishModalShow(true);
  },
  onSelectDeleteDish(index, i, step, flag) {
    const dishForTemp = this.state.deleteDish;
    const deleteDishCopy = this.state.deleteDishCopy;
    let isSelected = false;
    if (dishForTemp.order[index].isSelected === undefined) {
      isSelected = false;
    } else if (dishForTemp.order[index].isSelected[i] === undefined) {
      isSelected = false;
    } else {
      isSelected = dishForTemp.order[index].isSelected[i];
    }
    let count = dishForTemp.order[index].countChange === undefined ? dishForTemp.order[index].count : dishForTemp.order[index].countChange;
    if (!isSelected) {
      count -= step;
    } else {
      count += step;
    }
    this.setState({
      deleteDishCopy: deleteDishCopy.setIn(['order', index, 'count'], count),
      deleteDish: dishForTemp.setIn(['order', index, 'isSelected', i], !isSelected).setIn(['order', index, 'countChange'], count),
    });
  },
  buildDishCounter(args) {
    const { dish, count, remainCount } = args;
    const leastCellNum = Math.max(dish.leastCellNum, 1);
    let maximum = count + remainCount;
    let minimum = 0;
    let msg = { minimumMsg: '', maximumMsg: '' };
    // 必选
    if (dish.isReplace) {
      minimum = leastCellNum;
      msg.minimumMsg = <FormattedMessage {...dishMenuMessages.mustCheckedMinCount} values={{ minimum }} />;
      if (!dish.isMulti) {
        maximum = minimum;
        msg.maximum = <FormattedMessage {...dishMenuMessages.notMoreMaxCount} values={{ maximum }} />;
      }
    } else {
      minimum = 0;
      if (dish.isMulti) {
        if (maximum < leastCellNum) {
          maximum = 0;
        }
      } else {
        maximum = leastCellNum > maximum ? 0 : leastCellNum;
        msg.maximum = <FormattedMessage {...dishMenuMessages.notMoreMaxCount} values={{ maximum }} />;
      }
    }

    if (maximum < minimum) {
      maximum = minimum = 0;
      msg.maximumMsg = <FormattedMessage {...globalMessages.onLimitMax} />;
    }
    return (
      <Counter
        count={count}
        maximum={maximum}
        minimum={minimum}
        onCountChange={this.onCountChange}
        onTouchTap={this.onSetBlockIdx}
        msg={msg}
        ifShowToolTip
        showHandleInput={this.props.showHandleInput}
      />
    );
  },
  buildDishCounter2(args) {
    const dishCount = helper.getDishesCount([this.props.dish]);
    const { tempDish, count2, remainCount } = args;
    const leastCellNum = Math.max(tempDish.leastCellNum, 1);
    let maximum = remainCount;
    let minimum = dishCount >= leastCellNum ? 1 : leastCellNum;
    let msg = { minimumMsg: <FormattedMessage {...dishMenuMessages.leastCellNum} values={{ leastCellNum }} />, maximumMsg: '' };

    if (leastCellNum <= dishCount) {
      minimum = 1;
      msg.minimumMsg = <FormattedMessage {...dishMenuMessages.chooseMinCount} values={{ count: 1 }} />;
    }
    if (!tempDish.isMulti) {
      maximum = leastCellNum;
      if (leastCellNum === dishCount) {
        maximum = 0;
      }
      msg.maximumMsg = <FormattedMessage {...dishMenuMessages.chooseMaxCount} values={{ count: leastCellNum }} />;
    }

    if (remainCount < maximum || maximum < minimum) {
      maximum = minimum = 0;
      msg.maximumMsg = <FormattedMessage {...globalMessages.onLimitMax} />;
    }

    if (minimum === 0 && maximum === 0) {
      addToGroupFlag = false;
    }

    return (
      <Counter
        count={minimum === 0 && maximum === 0 ? 0 : count2}
        maximum={maximum}
        minimum={minimum}
        onCountChange={this.onCountChange2}
        msg={msg}
        ifShowToolTip
        showHandleInput={this.props.showHandleInput}
      />
    );
  },
  buildOrderBtn(dish, hasProps, remainCount, count) {
    const { expand } = this.state;
    if (dish.clearStatus) {
      return (
        <span className="dish-item-soldout">
          <FormattedMessage {...dishMenuMessages.soldout} />
        </span>
      );
    }
    if (hasProps) {
      let countStyle = {};
      if (count < 10) {
        countStyle = { width: '15px' };
      } else if (count >= 10 && count <= 99) {
        countStyle = { width: '21px' };
      } else {
        countStyle = { width: '27px' };
      }
      return (
        <div className="right">
          <span
            // onTouchTap={evt => this.onDishDeleteTap(evt)}
            onTouchTap={evt => this.onDeleteToGroupTap2(evt)}
            className={classnames({ 'dish-delete': true, 'dish-hide': expand || count <= 0 })}
          />
          <button
            // className="dish-dropdown-trigger btn--ellips"
            className={classnames('dish-dropdown-trigger btn--ellips', { 'btn--grey': remainCount <= 0 })}
            onTouchTap={evt => {
              if (remainCount <= 0) return false;
              return this.onPropsBtnTap(evt);
            }}
          >
            <FormattedMessage {...dishMenuMessages.choseSpecification} />
            <span className={classnames('child-dish--counter counter-special', { 'dish-hide': count <= 0 })} style={countStyle}>
              {count > 99 ? '99+' : count}
            </span>
          </button>
        </div>
      );
    }
    return this.buildDishCounter({ dish, remainCount, count });
  },
  buildDetailInfo(dish) {
    if (!dish.order[0]) return false;
    const { dishPropertyTypeInfos, dishIngredientInfos } = dish.order[0];
    const RecipeProps = dishPropertyTypeInfos.filter(propInfo => propInfo.type === 1);
    const NoteProps = dishPropertyTypeInfos.filter(propInfo => propInfo.type === 3);
    function buildPropsText(propsInfo) {
      const checkedProps = propsInfo.properties.filter(props => props.isChecked);
      if (checkedProps.length > 0) {
        return `${propsInfo.name}: ${checkedProps.map(props => props.name).join('、')}`;
      }
      return '';
    }
    return (
      <div className="detail-props-info">
        {RecipeProps.map(propInfo => buildPropsText(propInfo))
          .filter(propsText => propsText)
          .concat(
            [buildPropsText({ name: formatMessage(dishMenuMessages.ingredients), properties: dishIngredientInfos })].filter(propsText => propsText),
            NoteProps.map(propInfo => buildPropsText(propInfo)).filter(propsText => propsText),
          )
          .join(' | ')}
      </div>
    );
  },
  buildDeleteDishes(allDish) {
    function divideDishes(dish) {
      return [].concat.apply(
        [],
        dish.order.map((dishOrder, idx) => {
          return [Object.assign({}, dish, { key: `${dish.id}-${idx}` }, { order: [Object.assign({}, dishOrder)] })];
        }),
      );
    }
    const childDishes = divideDishes(allDish);
    const step = allDish.leastCellNum ? allDish.leastCellNum : 1;
    const list = (length, dish, idx) => {
      const res = [];
      for (let i = 0; i < length; i === 0 ? (i += step) : (i += 1)) {
        res.push(
          <div
            key={`${idx}-${i}`}
            data-attr={idx}
            className="child-dish child-dish--delete"
            onTouchTap={evt => {
              evt.preventDefault();
              return this.onSelectDeleteDish(idx, i, i === 0 ? step : 1, i === 0);
            }}
          >
            <div
              className={classnames('dish-name-wrap', {
                'is-selected': dish.order[0].isSelected && dish.order[0].isSelected[i],
                'dish-name-after': dish.order[0].isSelected && dish.order[0].isSelected[i],
              })}
            >
              <div>
                <div className="dish-name o-text-ellipsis">
                  {helper.generateDishNameWithUnit(dish)}
                  <div className="dish-count">x{i === 0 ? step : 1}</div>
                </div>
              </div>
              {this.buildDetailInfo(dish)}
            </div>
          </div>,
        );
      }
      return res;
    };

    return childDishes.map((dish, idx) => (!dish.order[0].count ? false : list(dish.order[0].count, dish, idx)));
  },
  render() {
    const { dish, remainCount, forCartModal, showMemberPriceInfo } = this.props;
    const { order, memberMarketPrice } = dish;
    const chooseOrderNum = typeof order === 'number' ? order : order[0].count;
    const { deleteDish, tempDish, expand, deleteExpand } = this.state;
    const hasProps = !helper.isSingleDishWithoutProps(dish);
    const count = helper.getDishesCount([dish]);
    const count2 = helper.getDishesCount([tempDish]);
    const marketPrice = dish.marketPrice || 0;
    if (forCartModal && count <= 0) {
      return false;
    }

    return (
      <div className="child-dish">
        <div className="child-dish__img">
          <HttpsProtocolImage src={dish.imageUrl} alt="" />
        </div>
        <div className="dish-name-wrap" style={{ flex: 1 }}>
          {forCartModal && count > 0 ? (
            <div>
              <div className={classnames('dish-name o-text-ellipsis')}>
                {helper.generateDishNameWithUnit(dish)}
                {marketPrice !== 0 ? (
                  <span className="badge-price">
                    {marketPrice > 0 ? '+ ' : ''}
                    {memberMarketPrice > 0 && (
                      <span className="price" style={{ marginRight: '5px' }}>
                        {memberMarketPrice}
                      </span>
                    )}
                    <span className={classnames('price', { 'child-dish__line_thought': memberMarketPrice > 0 })}>{marketPrice}</span>
                  </span>
                ) : (
                  false
                )}
                {dish.isReplace ? <span className="badge-bi" data-bi={formatMessage(dishMenuMessages.must)} /> : false}
              </div>
              <div className="dish-count">x{count}</div>
            </div>
          ) : (
            false
          )}
          {forCartModal ? (
            this.buildDetailInfo(dish)
          ) : (
            <div>
              <div className={classnames('dish-name o-text-ellipsis', { 'dish-name-after': chooseOrderNum })}>
                {helper.generateDishNameWithUnit(dish)}
                {marketPrice !== 0 ? (
                  <span className="badge-price">
                    {marketPrice > 0 ? '+ ' : ''}
                    {/* {memberMarketPrice > 0 && ( */}
                    {memberMarketPrice >= 0 && (
                      <span className="price" style={{ marginRight: '5px' }}>
                        {memberMarketPrice}
                      </span>
                    )}
                    {/* <span className={classnames('price', { 'child-dish__line_thought': memberMarketPrice > 0 })}>{marketPrice}</span> */}
                    <span className={classnames('price', { 'child-dish__line_thought': memberMarketPrice >= 0 })}>{marketPrice}</span>
                  </span>
                ) : (
                  false
                )}
                {dish.isReplace ? <span className="badge-bi" data-bi={formatMessage(dishMenuMessages.must)} /> : false}
              </div>
              {this.buildOrderBtn(dish, hasProps, remainCount, count)}
            </div>
          )}
        </div>
        {expand ? (
          <div>
            <div className="dish-detail-modal-mask" onTouchTap={this.onCloseModalTap} />
            <div className="dish-detail-modal">
              <div className="dish-detail-close--modify" onTouchTap={this.onCloseModalTap}>
                <a className="btn-close" />
              </div>
              <DishDetailHead showMemberPriceInfo={showMemberPriceInfo} dish={tempDish} onCountChange={this.onDishItemCountChange} />
              <DishPropsSelect showMemberPriceInfo={showMemberPriceInfo} dish={tempDish} onSelectPropsOption={this.onSelectPropsOption2} />
              <div className="dish-detail-addtocarta o-flex__fixed o-border--top">
                {this.buildDishCounter2({ tempDish, remainCount, count2 })}
                <div style={{ flex: 1 }}>
                  <button
                    className={classnames('btn--yellow', { 'btn--grey': dish.clearStatus })}
                    onTouchTap={evt => {
                      evt.preventDefault();
                      if (dish.clearStatus) {
                        return false;
                      }
                      return this.onAddToGroupTap();
                    }}
                  >
                    <FormattedMessage {...dishMenuMessages.addToGroup} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          false
        )}
        {deleteExpand ? (
          <div>
            <div className="dish-detail-modal-mask" onTouchTap={this.onCloseDeleteModalTap} />
            <div className="dish-detail-modal dish-detail-modal--delete o-flex o-flex--column">
              <a className="btn-close" onTouchTap={this.onCloseDeleteModalTap} />
              <div className="dish-detail-head o-flex__fixed">
                <FormattedMessage {...dishMenuMessages.chooseDeleteDish} />
              </div>
              <div className="o-flex__fluid">{this.buildDeleteDishes(deleteDish)}</div>
              <div className="dish-detail-addtocarta o-flex__fixed o-border--top">
                <button
                  className="btn-delete"
                  onTouchTap={evt => {
                    evt.preventDefault();
                    return this.onDeleteToGroupTap();
                  }}
                >
                  <FormattedMessage {...dishMenuMessages.confirmDelete} />
                </button>
              </div>
            </div>
          </div>
        ) : (
          false
        )}
        {this.state.toast === 1 && (
          <div className="c-toast">
            <div className="c-toast__content">
              <img src={toastIcon} style={{ width: 28 }} alt="" />
              {this.state.toastText}
            </div>
          </div>
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/group-dish-detail/child-dish.jsx